export default __webpack_public_path__ + "static/profile-7cc2ca6f892db18f6003669b370dd07c.png";